import { useEffect, useState, Fragment } from 'react';
import { forwardRef, useImperativeHandle } from "react"
import { decodeWinData } from "./win.js";
import { calcspectrum, hzarray } from "./fft.js"
import Healthmonitoringbars from "./healthmonitoringbars.js"
import Healthmonitoringtmaxvalues from "./healthmonitoringmaxvalues.js"
import styles from './css/healthmonitoringgraphs.module.css'
import invoke from "../calllambda.js"
import Kegaki from "./kegaki.js"
import WinGraph from "./wingraph.js"
import SpcGraph from "./spcgraph.js"

const Helthmonitoringgraphs = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        download() { csvdownload() }
    }))

    const unit = { ACC: "加速度(gal)", VEL: "速度(kine)", DSP: "変位(cm)" };
    const [data, setdata] = useState([]);
    const [wins, setWins] = useState({});
    const [windata, setWindata] = useState(null);
    const [maxvals, setMaxvals] = useState({});
    const [damage, setDamage] = useState([]);
    const [estimate, setEstimate] = useState([]);
    const [wavkind, setWavkind] = useState("ACC")
    const [spckind, setSpckind] = useState("ACC")
    const [maxspcval, setMaxspcval] = useState(null);

    useEffect(() => {
        if (!props.visible) return;
        var aestimate = Object.values(props.event.estimate);
        var adamage = Object.values(props.event.damage);
        aestimate.reverse()
        adamage.reverse()
        setEstimate(aestimate)
        setDamage(adamage)
        //グラフ最大値
        var maxacc = 0, maxvel = 0, maxdsp = 0;
        aestimate.forEach((avalue) => {
            maxacc = Math.max(maxacc, avalue.max_gal_x, avalue.max_gal_y, avalue.max_gal_z);
            maxvel = Math.max(maxvel, avalue.max_kine_x, avalue.max_kine_y, avalue.max_kine_z);
            maxdsp = Math.max(maxdsp, avalue.max_cm_x, avalue.max_cm_y, avalue.max_cm_z);
        });
        setMaxvals({ ACC: maxacc, VEL: maxvel, DSP: maxdsp });
        //windata
        setdata([])
        invoke("arn:aws:lambda:ap-northeast-1:068557983663:function:downloadeventwins", { sensor_id: props.event.sensor_id, datetime: props.event.datetime }).then(function (value) {
            setWindata(value);
        });
    }, [props.event, props.visible]);

    useEffect(() => {
        if (windata == null) return;
        var awins = {
            ACC: adjustacc(decodeWinData(Uint8Array.from(atob(windata.acc), s => s.charCodeAt(0)))),
            VEL: decodeWinData(Uint8Array.from(atob(windata.vel), s => s.charCodeAt(0))),
            DSP: decodeWinData(Uint8Array.from(atob(windata.dsp), s => s.charCodeAt(0)))
        }
        setWins(awins)
     }, [windata]);

    function adjustacc(winObj) {
        for (var i = 0; i < winObj.x.length; i++) {
            var avg1 = 0;
            var avg2 = 0;
            var avg3 = 0;
            for (var j = 0; j < winObj.x[i].length; j++) {
                avg1 += winObj.x[i][j];
                avg2 += winObj.y[i][j];
                avg3 += winObj.z[i][j];
            }
            avg1 = avg1 / winObj.x[i].length;
            avg2 = avg2 / winObj.y[i].length;
            avg3 = avg3 / winObj.z[i].length;
            for (j = 0; j < winObj.x[i].length; j++) {
                winObj.x[i][j] = winObj.x[i][j] - avg1;
                winObj.y[i][j] = winObj.y[i][j] - avg2;
                winObj.z[i][j] = winObj.z[i][j] - avg3;
            }
        }
        return winObj;
    }

    function calcspc() {
        var spcs = [];
        var maxval = 0;
        if (wins[spckind]) {
            let spcObj = wins[spckind];
            for (var i = 0; i < spcObj.x.length; i++) {
                var x = calcspectrum(spcObj.x[i]);
                var y = calcspectrum(spcObj.y[i]);
                var z = calcspectrum(spcObj.z[i]);
                var hz = hzarray(x, 100);
                spcs.push({
                    x: x, y: y, z: z,
                    hzX: hz, hzY: hz, hzZ: hz,
                });
                var idx = 0;
                for (; idx < hz.length; idx++) {
                    if (hz[idx] >= 0.1) break;
                }
                maxval = Math.max(...x.slice(idx), ...y.slice(idx), ...z.slice(idx), maxval)
            }
        }
        setMaxspcval(maxval);
        return spcs;
    }

    function getwav(kind) {
        var wavs = [];
        if (wins[kind]) {
            let winObj = wins[kind];
            for (var i = 0; i < winObj.x.length; i++) {
                wavs.push({
                    x: winObj.x[i], y: winObj.y[i], z: winObj.z[i],
                    tsX: winObj.tsX[i], tsY: winObj.tsY[i], tsZ: winObj.tsZ[i],
                });
            }
        }
        return wavs;
    }

    useEffect(() => {
        var dataObjs = [];
        var win = getwav(wavkind);
        var spc = calcspc(spckind);
        var kegaki = getwav("DSP");
        for (var i = 0; i < win.length; i++) {
            dataObjs.push({ win: win[i], kegaki: kegaki[i], spc: spc[i] });
        }
        dataObjs.reverse();
        setdata(dataObjs);
    }, [wins])

    useEffect(() => {
        var dataObjs = [];
        var win = getwav(wavkind);
        for (var i = 0; i < data.length; i++) {
            dataObjs.push({ win: win[data.length - i - 1], kegaki: data[i]["kegaki"], spc: data[i]["spc"] });
        }
        setdata(dataObjs);
    }, [wavkind])

    useEffect(() => {
        var dataObjs = [];
        var spc = calcspc(spckind);
        for (var i = 0; i < data.length; i++) {
            dataObjs.push({ win: [i]["win"], kegaki: data[i]["kegaki"], spc: spc[data.length - i - 1] });
        }
        setdata(dataObjs);
    }, [spckind])
    /*
        useEffect(() => {
            if (wins[spckind]) {
                let winObj = wins[wavkind];
                let kegakiObj = wins["DSP"];
                let spcObj = wins[spckind];
                var dataObjs = [];
                var win = {};
                var spc = {};
                var kegaki = {};
                var maxval = null;
                for (var i = 0; i < winObj.x.length; i++) {
                    win = {
                        x: winObj.x[i], y: winObj.y[i], z: winObj.z[i],
                        tsX: winObj.tsX[i], tsY: winObj.tsY[i], tsZ: winObj.tsZ[i],
                    }
                    kegaki = {
                        x: kegakiObj.x[i], y: kegakiObj.y[i], z: kegakiObj.z[i],
                        tsX: kegakiObj.tsX[i], tsY: kegakiObj.tsY[i], tsZ: kegakiObj.tsZ[i],
                    }
                    var x = calcspectrum(spcObj.x[i]); 
                    var y = calcspectrum(spcObj.y[i]);
                    var z = calcspectrum(spcObj.z[i]);
                    var hz = hzarray(x,100);
                    spc = {
                        x: x, y: y, z: z,
                        hzX: hz, hzY: hz, hzZ: hz,
                    }
                    dataObjs.push({win: win, kegaki: kegaki, spc: spc});
                    var idx=0;
                    for (; idx < hz.length; idx++) {
                        if ( hz[idx] >= 0.1 ) break;
                    }
                    maxval = Math.max(...x.slice(idx),...y.slice(idx),...z.slice(idx),maxval)
                }
                dataObjs.reverse()
                setdata(dataObjs);
                setMaxspcval(maxval);
            }
        } , [wavkind,spckind,wins])
    */
    function formatDate(datetime) {
        if (datetime == null) return null;
        const modified = new Date(datetime);
        const year = modified.getFullYear();
        const month = ("0" + (modified.getMonth() + 1)).slice(-2);
        const date = ("0" + modified.getDate()).slice(-2);
        const hours = ("0" + modified.getHours()).slice(-2);
        const minutes = ("0" + modified.getMinutes()).slice(-2);
        const seconds = ("0" + modified.getSeconds()).slice(-2);
        const mseconds = ("0000" + modified.getMilliseconds()).slice(-3);
        return year + "-" + month + "-" + date + "T" + hours + ":" + minutes + ":" + seconds + "." + mseconds;
    };

    function csvdownload() {
        const isodate = formatDate(new Date(wins["ACC"].tsX[0][0]));
        const filename = "event_" + isodate.substring(0, 4) + isodate.substring(5, 7) + isodate.substring(8, 10) + isodate.substring(11, 13) + isodate.substring(14, 16) + isodate.substring(17, 19) + ".csv"
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        var csv = "isotime,";
        for (var i = 0; i < wins["ACC"].x.length; i++) {
            var fname = floorname(wins["ACC"].x.length - i - 1);//逆
            csv += ("accX_" + fname + "[gal],accY_" + fname + "[gal],accZ_" + fname + "[gal],velX_" + fname + "[kine],velY_" + fname + "[kine],velZ_" + fname + "[kine],dspX_" + fname + "[cm],dspY_" + fname + "[cm],dspZ_" + fname + "[cm],");
        }
        csv = csv.slice(0, -1) + "\n";
        for (i = 0; i < wins["ACC"].x[0].length; i++) {
            const date = new Date(wins["ACC"].tsX[0][i]);
            var line = formatDate(date) + ",";
            for (var j = 0; j < wins["ACC"].x.length; j++) {
                line += (wins["ACC"].x[j][i] + "," + wins["ACC"].y[j][i] + "," + wins["ACC"].z[j][i] + ",")
                    + (wins["VEL"].x[j][i] + "," + wins["VEL"].y[j][i] + "," + wins["VEL"].z[j][i] + ",")
                    + (wins["DSP"].x[j][i] + "," + wins["DSP"].y[j][i] + "," + wins["DSP"].z[j][i] + ",");
            }
            csv += line.slice(0, -1) + "\n";
        }
        const blob = new Blob([bom, csv], { type: "text/csv" })
        const link = document.createElement('a')
        link.download = filename
        link.href = URL.createObjectURL(blob)
        link.click()
        URL.revokeObjectURL(link.href)
    }

    function floorname(no) {
        return ((damage[no]?.floor != undefined) ? damage[no].floor : data.length - no + "F");
    }

    function isestimate(no) {
        return estimate[no]?.estimate ? "(推定)" : "(実測)";
    }

    return (
        data.length==0 ? <div>データ読み込み中</div> :
        <div className={styles.container}>
            <div></div>
            <div>時刻歴波形
                <select className="form-select-sm" required id="wav_kind" onChange={(event) => { setWavkind(event.target.value); }}>
                    <option value="ACC">加速度</option>
                    <option value="VEL">速度</option>
                    <option value="DSP">変位</option>
                </select>
            </div>
            <div>スペクトル
                <select className="form-select-sm" required id="spc_kind" onChange={(event) => { setSpckind(event.target.value); }}>
                    <option value="ACC">加速度</option>
                    <option value="VEL">速度</option>
                    <option value="DSP">変位</option>
                </select>
            </div>
            <div style={{ textAlign: "center" }}>罫書き<br /><span style={{ fontSize: "smaller" }}>(水平)</span></div>
            <div style={{ textAlign: "center" }}>最大応答<br /><span style={{ fontSize: "smaller" }}>(左:長手方向、右:短手方向)</span></div>
            <div style={{ textAlign: "center" }}>被災度判定<br /><span style={{ fontSize: "smaller" }}>(最大応答での判定結果)</span></div>
            <div className={styles.border}>&nbsp;</div><div className={styles.border}>&nbsp;</div><div className={styles.border}>&nbsp;</div><div className={styles.border}>&nbsp;</div><div className={styles.border}>&nbsp;</div><div className={styles.border}>&nbsp;</div>
            {data.map((onedata, idx) => {
                return (
                    <Fragment key={idx}>
                        <div className={styles.item}><div className={styles.floor}>
                            <span className={styles.block}>{floorname(idx)}</span>
                            <br /><span className={styles.block}>{isestimate(idx)}</span>
                        </div></div>
                        <div className={styles.item}>
                            <WinGraph windata={onedata.win} height={props.height} unit={unit[wavkind]} maxval={maxvals[wavkind]} />
                        </div>
                        <div className={styles.item}>
                            <SpcGraph windata={onedata.spc} height={props.height} maxval={maxspcval} />
                        </div>
                        <div className={styles.item} style={{ alignItems: "center", textAlign: "center" }}>
                            <Kegaki windata={onedata.kegaki} height={props.height} maxval={maxvals["DSP"]} />
                        </div>
                        <div className={styles.item}>
                            <Healthmonitoringtmaxvalues value={estimate[idx]} />
                        </div>
                        <div className={styles.item}>
                            <Healthmonitoringbars damage={damage[idx]} />
                        </div>
                        <div className={styles.border}>&nbsp;</div><div className={styles.border}>&nbsp;</div><div className={styles.border}>&nbsp;</div><div className={styles.border}>&nbsp;</div><div className={styles.border}>&nbsp;</div><div className={styles.border}>&nbsp;</div>
                    </Fragment>
                )
            })}
        </div>
    );
})

export default Helthmonitoringgraphs;